<template>
  <div class="modify-detail__actions">
    <div
      v-if="showIataMessage"
      class="modify-detail__actions-block"
    >
      <div class="modify-detail__actions-iata-alert">
        <span class="icon-warning" />
        <span>
          {{ iataMessage }}
        </span>
      </div>
    </div>
    <div
      v-if="showModifyActionSidebarBlock"
      class="modify-detail__actions-block"
    >
      <div class="modify-detail__actions-title">
        {{ ModifyReservationTitle }}
      </div>
      <div class="modify-detail__actions-button">
        <modify-edit-modal>
          <div
            slot-scope="{ activate }"
            class=""
          >
            <button
              class="button--secondary black size-md outlined"
              @click="activate"
              @keydown.space.prevent="activate"
              @keydown.enter.prevent="activate"
            >
              {{ ModifyReservationCTALabel }}
            </button>
          </div>
        </modify-edit-modal>
      </div>
    </div>
    <div class="modify-detail__actions-block">
      <div
        v-if="showCancelActionSidebarBlock"
        class="modify-detail__actions-title"
      >
        {{ CancelReservationTitle }}
      </div>
      <div
        v-if="showCancelActionSidebarBlock"
        class="modify-detail__actions-button"
      >
        <modify-cancel-modal>
          <div slot-scope="{ activate }">
            <button
              class="button--secondary black size-md outlined"
              @click="activate"
              @keydown.space.prevent="activate"
              @keydown.enter.prevent="activate"
            >
              {{ CancelReservationCTALabel }}
            </button>
          </div>
        </modify-cancel-modal>
      </div>
      <toggle-details :data-open-on-init="openCancelPolicyToggleOnInit ? 'true' : 'false'">
        <div slot-scope="{ opened, toggle, isMounted }">
          <div
            class="modify-detail__actions-cancellation-policy-wrapper"
            :class="[{ opened },
                     {'no-divider':openCancelPolicyToggleOnInit},
                     {'divider':!openCancelPolicyToggleOnInit},
                     {'no-margin-top': !showCancelActionSidebarBlock}]"
          >
            <div class="activator">
              <div v-if="openCancelPolicyToggleOnInit">
                <div :class="`policy-block ${ openCancelPolicyToggleOnInit ? 'disable' : ''} `">
                  <div class="policy-title">
                    <span v-if="!isMultiRoomReservation">{{ cancelReservationPolicyLabelSingular }}</span>
                    <span v-if="isMultiRoomReservation">{{ cancelReservationPolicyLabelPlural }}</span>
                  </div>
                </div>
              </div>
              <div
                v-if="!openCancelPolicyToggleOnInit"
                role="button"
                tabindex="0"
                :aria-expanded="opened ? 'true' : 'false'"
                @click="toggle"
                @keydown.enter.prevent="toggle"
                @keydown.space.prevent="toggle"
              >
                <div :class="`policy-block ${ openCancelPolicyToggleOnInit ? 'disable' : ''} `">
                  <div class="policy-title">
                    <span v-if="!isMultiRoomReservation">{{ cancelReservationPolicyLabelSingular }}</span>
                    <span v-if="isMultiRoomReservation">{{ cancelReservationPolicyLabelPlural }}</span>
                  </div>
                  <div :class="opened ? 'icon-minus' : 'icon-add'" />
                </div>
              </div>
            </div>
            <div
              class="policy-list"
              :class="[{ opened: opened }, {'no-margin-top': !isMultiRoomReservation}]"
            >
              <transition-group name="expand-y">
                <div
                  v-if="opened"
                  key="cancellation-policy__list"
                >
                  <div
                    v-for="reservation in currentReservationData.reservations"
                    :key="reservation.id"
                    class="policy-item"
                    :class="[{'single': !isMultiRoomReservation}]"
                  >
                    <div
                      v-if="isMultiRoomReservation"
                      class="policy-room-label"
                    >
                      {{ ModifyReservationRoomTitle }} {{ reservation.roomNumberOrder }}:
                      {{ reservation.roomStays[0].roomName }}
                    </div>
                    <ul
                      class="policy-description list-indent"
                      v-html="renderCancelPenaltiesText(reservation.cancelPenaltiesText)"
                    />
                  </div>
                </div>
              </transition-group>
            </div>
          </div>
        </div>
      </toggle-details>
    </div>
    <div class="modify-detail__actions-block">
      <div class="modify-detail__actions-question">
        {{ QuestionTitle }}
      </div>
      <ul class="modify-detail__actions-text list-indent">
        <li
          v-if="currentReservationData.property.liveChat !==''"
          class="live-chat"
        >
          <a
            target="_blank"
            :href="currentReservationData.property.liveChat"
          >{{ QuestionLiveChatTitle }}</a>
        </li>
        <li
          v-if="currentReservationData.property.phone !==''"
          class="phone"
        >
          {{ QuestionPhoneTitle }} <a :href="`tel:${currentReservationData.property.phone}`">{{ currentReservationData.property.phone }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import modifyCancelModal from '../modals/modify-cancel-modal.vue'
  import modifyEditModal from '../modals/modify-edit-modal.vue'

  export default {
    name: 'ModifyChangeActions',
    components: {
      modifyCancelModal,
      modifyEditModal,
    },
    computed: {
      ...mapState('modifyReservation', [
        'cancelledState',
        'currentReservationData',
        'modifyBookingPropData',
        'allReservationsAreCancelled',
      ]),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters(
        'modifyReservation', ['isMultiRoomReservation']
      ),
      ModifyReservationDescription() {
        return this.modifyBookingPropData?.ModifyReservationDescription
          ? this.modifyBookingPropData.ModifyReservationDescription
          : ''
      },
      ModifyReservationTitle() {
        return this.modifyBookingPropData?.ModifyReservationTitle
          ? this.modifyBookingPropData.ModifyReservationTitle
          : ''
      },
      ModifyReservationCTALabel() {
        return this.modifyBookingPropData?.ModifyReservationCTALabel
          ? this.modifyBookingPropData.ModifyReservationCTALabel
          : ''
      },
      CancelReservationTitle() {
        return this.modifyBookingPropData?.CancelReservationTitle
          ? this.modifyBookingPropData.CancelReservationTitle
          : ''
      },
      CancelReservationDescription() {
        return this.modifyBookingPropData?.CancelReservationDescription
          ? this.modifyBookingPropData.CancelReservationDescription
          : ''
      },
      CancelReservationCTALabel() {
        return this.modifyBookingPropData?.CancelReservationCTALabel
          ? this.modifyBookingPropData.CancelReservationCTALabel
          : ''
      },
      QuestionTitle() {
        return this.modifyBookingPropData?.QuestionTitle
          ? this.modifyBookingPropData.QuestionTitle
          : ''
      },
      QuestionLiveChatTitle() {
        return this.modifyBookingPropData?.QuestionLiveChatTitle
          ? this.modifyBookingPropData.QuestionLiveChatTitle
          : ''
      },
      QuestionPhoneTitle() {
        return this.modifyBookingPropData?.QuestionPhoneTitle
          ? this.modifyBookingPropData.QuestionPhoneTitle
          : ''
      },
      showModifyActionSidebarBlock() {
        return this.anyReservationsModifiable
      },
      showCancelActionSidebarBlock() {
        return this.anyReservationsCancellable
      },
      anyReservationsModifiable() {
        return this.currentReservationData.reservations.some((reservation) => reservation.isModifiable)
      },
      anyReservationsCancellable() {
        return this.currentReservationData.reservations.some((reservation) => reservation.isCancellable)
      },
      ModifyReservationRoomTitle() {
        return this.modifyBookingPropData?.ModifyReservationRoomTitle
          ? this.modifyBookingPropData.ModifyReservationRoomTitle
          : ''
      },
      cancelReservationPolicyLabelSingular() {
        return this.modifyBookingPropData?.CancelReservationPolicyLabelSingular
          ? this.modifyBookingPropData.CancelReservationPolicyLabelSingular
          : ''
      },
      cancelReservationPolicyLabelPlural() {
        return this.modifyBookingPropData?.CancelReservationPolicyLabelPlural
          ? this.modifyBookingPropData.CancelReservationPolicyLabelPlural
          : ''
      },
      openCancelPolicyToggleOnInit() {
        return this.currentReservationData?.reservations.length <= 2
      },
      atLeastOneOtherSourceTrue() {
        return this.currentReservationData?.reservations.some((reservation) => reservation.otherSource)
      },
      atLeastOneNotIruChecked() {
        return this.currentReservationData?.reservations.some((reservation) => (
          !reservation.iruVerified
        ))
      },
      allHasIruChecked() {
        return this.currentReservationData?.reservations
          .every((reservation) => reservation.iruVerified)
      },
      showIataMessage() {
        return this.atLeastOneNotIruChecked || (this.allHasIruChecked && this.atLeastOneOtherSourceTrue)
      },
      iataMessage() {
        if (this.atLeastOneNotIruChecked) {
          return this.tc('booking.modifyIruNotVerifiedMessage')
        }
        if (this.allHasIruChecked && this.atLeastOneOtherSourceTrue) {
          return this.tc('booking.modifyOtherSourceMessage')
        }
        return ''
      },

    },
    methods: {
      renderCancelPenaltiesText(cancelPolicyHtml) {
        const markupWithHtml = /<li>/.test(cancelPolicyHtml)
        return markupWithHtml ? cancelPolicyHtml : `<li>${cancelPolicyHtml}</li>`
      }
    }
  }
</script>
